module.exports = __webpack_public_path__ + "img/expertWebinar.a6836c95.svg";